module.exports = {
      id: "icon-login-usage",
      viewBox: "0 0 10.66 10.66",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-login",
      toString: function () {
        return this.url;
      }
    }